/**
 * Size Guide Drawer Web Component
 * Handles the open/close functionality of the size guide drawer
 */

class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    // Close button
    const closeButton = this.querySelector('.drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }

    // Overlay click
    const overlay = this.querySelector('.size-guide-drawer__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.close());
    }

    // Escape key - listen on document for better capture
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE' && this.classList.contains('active')) {
        this.close();
      }
    });

    // Listen for size guide trigger clicks
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-size-guide-trigger]');
      if (trigger) {
        event.preventDefault();
        this.open(trigger);
      }
    });
  }

  open(triggerElement = null) {
    this.activeElement = triggerElement || document.activeElement;
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (typeof trapFocus === 'function') {
          trapFocus(this.querySelector('.drawer__inner'), focusElement);
        } else {
          focusElement.focus();
        }
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    } else if (this.activeElement) {
      this.activeElement.focus();
    }
  }
}

customElements.define('size-guide-drawer', SizeGuideDrawer);
